import { render, staticRenderFns } from "./AddSupplierCost.vue?vue&type=template&id=2ef911d2&scoped=true&"
import script from "./AddSupplierCost.vue?vue&type=script&lang=js&"
export * from "./AddSupplierCost.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierCost.vue?vue&type=style&index=0&id=2ef911d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef911d2",
  null
  
)

export default component.exports